import request from '@/utils/request'

// 企业资讯列表(首页无权限)
export function examineNoAuthList(query) {
    return request({
        url: '/business/document/dataFormCokeBranchNew/noAuth/queryList',
        method: 'get',
        params: query
    })
}

// 企业资讯列表
export function examineList(query) {
    return request({
        url: '/business/document/dataFormCokeBranchNew/queryList',
        method: 'get',
        params: query
    })
}

// 企业资讯详情
export function examineDetail(query) {
    return request({
        url: '/business/document/dataFormCokeBranchNew/examineList',
        method: 'get',
        params: query
    })
}

// 行业动态列表(首页无权限)
export function industryNoAuthList(query) {
    return request({
        url: '/business/industry/noAuth/boardList',
        method: 'get',
        params: query
    })
}

// 行业动态二级页
export function industryPage(query) {
    return request({
        url: `/business/industry/cokeList`,
        method: 'get',
        params: query
    })
}

// 行业动态详情
export function industryDetail(id) {
    return request({
        url: `/business/industry/ironstoneCokeInfo/${id}`,
        method: 'get',
    })
}

// 研究报告列表(首页无权限)
export function reportNoAuthList(query) {
    return request({
        url: '/business/report/noAuth/List',
        method: 'get',
        params: query
    })
}

// 技术及标准列表
export function reportList(query) {
    return request({
        url: '/business/report/cokeTechnicalList',
        method: 'get',
        params: query
    })
}

// 技术及标准列表
export function reportLists(query) {
    return request({
        url: '/business/report/cokeList',
        method: 'get',
        params: query
    })
}

// 价格列表(首页无权限)
export function priceNoAuthList(query) {
    return request({
        url: '/business/metatron/price/noAuth/cokeList',
        method: 'get',
        params: query
    })
}

// 价格列表
export function pricePage(query) {
    return request({
        url: '/business/metatron/price/cokeList',
        method: 'get',
        params: query
    })
}

// 价格详情
export function priceDetail(query) {
    return request({
        url: '/business/metatron/price/detailsCokeList',
        method: 'get',
        params: query
    })
}

// 库存列表(首页无权限)
export function stockNoAuthList(query) {
    return request({
        url: '/business/metatron/stock/noAuth/cokeList',
        method: 'get',
        params: query
    })
}

// 库存列表
export function stockPage(query) {
    return request({
        url: '/business/metatron/stock/cokeList',
        method: 'get',
        params: query
    })
}

// 库存详情
export function stockDetail(query) {
    return request({
        url: '/business/metatron/stock/detailsCokeList',
        method: 'get',
        params: query
    })
}

// 开工率列表(首页无权限)
export function rateNoAuthList(query) {
    return request({
        url: '/business/metatron/rate/noAuth/cokeList',
        method: 'get',
        params: query
    })
}

// 开工率列表
export function ratePage(query) {
    return request({
        url: '/business/metatron/rate/cokeList',
        method: 'get',
        params: query
    })
}

// 开工率详情
export function rateDetail(query) {
    return request({
        url: '/business/metatron/rate/detailsCokeList',
        method: 'get',
        params: query
    })
}

// 进出口量列表
export function exitPage(query) {
    return request({
        url: '/business/metatron/exit/cokeList',
        method: 'get',
        params: query
    })
}

// 进出口量列表(首页无权限)
export function exitNoAuthList(query) {
    return request({
        url: '/business/metatron/exit/noAuth/cokeList',
        method: 'get',
        params: query
    })
}

// 进出口量详情
export function exitDetail(query) {
    return request({
        url: '/business/metatron/exit/detailsCokeList',
        method: 'get',
        params: query
    })
}

// 新增淘汰产能列表(首页无权限)
export function boardNoAuthList(query) {
    return request({
        url: '/business/board/noAuth/list',
        method: 'get',
        params: query
    })
}

// 新增淘汰产能详情
export function boardDetail() {
    return request({
        url: `/business/board/getCapacityList`,
        method: 'get',
    })
}

// 地图
export function mapData(query) {
    return request({
        url: '/business/metatron/yield/cokeYieldLine',
        method: 'get',
        params: query
    })
}

// 地图
export function mapDatas(query) {
    return request({
        url: '/business/metatron/price/cokeLineChart',
        method: 'get',
        params: query
    })
}

// 企业产能 （首页无权限）
export function getNoAuthCompanyCoke(query) {
    return request({
        url: '/business/metatron/companyCoke/noAuth/queryList',
        method: 'get',
        params: query
    })
}

// 研究报告详情
export function cokeReportDetail(id) {
    return request({
        url: `/business/report/cokeInfo/${id}`,
        method: 'get',
    })
}

// 技术及标准详情
export function reportDetails(id) {
    return request({
        url: `/business/report/cokeTechnicalInfo/${id}`,
        method: 'get',
    })
}

//全国产量 （首页无权限）
export function cokeYieldLine(query) {
    return request({
        url: '/business/metatron/yield/noAuth/cokeYieldLine',
        method: 'get',
        params: query
    })
}

// 企业产能 （详情）
export function detailsCokeYield(query) {
    return request({
        url: '/business/metatron/yield/detailsCokeYield',
        method: 'get',
        params: query
    })
}

// 企业产能 （按炉型产能分布 ）
export function getListGroupByModel(query) {
    return request({
        url: '/business/metatron/companyCoke/getListGroupByModel',
        method: 'get',
        params: query
    })
}

// 企业产能 （全国产能焦化区域分布）
export function getListRegionalDistribution(query) {
    return request({
        url: '/business/metatron/companyCoke/getListRegionalDistribution',
        method: 'get',
        params: query
    })
}

// 企业产能 （产能焦化一览）
export function companyCokeList(query) {
    return request({
        url: '/business/metatron/companyCoke/queryList',
        method: 'get',
        params: query
    })
}

// 讨论区
export function bulletinList(query) {
    return request({
        url: '/business/bulletin/list',
        method: 'get',
        params: query
    })
}

// 新增讨论
export function addBulletin(data) {
    return request({
        url: '/business/bulletin',
        method: 'post',
        data: data
    })
}

// 成本利润列表(首页无权限)/determination/noAuath/list
export function boardNoList(query) {
    return request({
        url: '/business/determination/noAuth/list',
        method: 'get',
        params: query
    })
}

// 成本利润列表
export function boardList(query) {
    return request({
        url: '/business/determination/boardList',
        method: 'get',
        params: query
    })
}

// 成本利润详情
export function determination(id) {
    return request({
        url: `/business/determination/${id}`,
        method: 'get',
    })
}

// 报表
export function getAuthFlagCoke() {
    return request({
        url: `/business/metatron/chain/cokeReport`,
        method: 'get',
    })
}
// 详情表
export function getAuthDetailReport() {
    return request({
        url: `/business/metatron/chain/coke/detailReportForm`,
        method: 'get',
    })
}
// 汇总表
export function getAuthSummaryReport() {
    return request({
        url: `/business/metatron/chain/coke/summaryReportForm`,
        method: 'get',
    })
}

